module.exports = __webpack_public_path__ + "static/img/0100.bdd4bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0100.jpg
// module id = CwvU
// module chunks = 1